<template>
  <div>
    <template v-if="type === 'normal' && !circle">
      <div class="row">
        <div class="col-sm-12">
          <div class="progress">
            <div
              class="progress-bar"
              :class="{
                'progress-bar-success': percentual === 100,
                'progress-bar-info': percentual < 100,
                'progress-bar-warning': percentual < 50,
                'progress-bar-danger': percentual < 30
              }"
              role="progressbar"
              aria-valuenow=""
              aria-valuemin="0"
              aria-valuemax="100"
              :style="style"
            >
              <strong>{{ percentual }}%</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-right">
          <a href="#" @click.prevent="modal = true">Ver pendências</a>
        </div>
      </div>
    </template>
    <template v-if="type === 'small' && !circle">
      <span
        :class="{
          'text-success': percentual === 100,
          'text-info': percentual < 100,
          'text-warning': percentual < 50,
          'text-danger': percentual < 30
        }"
        role="progressbar"
        aria-valuenow=""
        aria-valuemin="0"
        aria-valuemax="100"
        :style="style"
      >
        <a href="#" @click.prevent="onClick" class="text-white">
          <i class="fa fa-info-circle"></i> {{ linkTitle }}
        </a>
        <div class="progress">
          <div
            class="progress-bar"
            :class="{
              'progress-bar-success': percentual === 100,
              'progress-bar-info': percentual < 100,
              'progress-bar-warning': percentual < 50,
              'progress-bar-danger': percentual < 30
            }"
            role="progressbar"
            aria-valuenow=""
            aria-valuemin="0"
            aria-valuemax="100"
            :style="style"
          >
            <strong>{{ percentual }}%</strong>
          </div>
        </div>
      </span>
    </template>
    <template v-if="circle">
      <span @click.prevent="onClick">
        <div
          class="circulo"
          :class="{
            'alert-success': percentual === 100,
            'alert-warning': percentual < 100,
            'alert-danger': percentual < 50
          }"
        >
          <div
            class="progress-bar"
            style="border-radius: 50%; display: flex; align-items: center; justify-content: center;"
          >
            <strong style="line-height: 35px; text-align: center; margin-left: 34px;"
              >{{ Math.round(percentual) }}%</strong
            >
          </div>
        </div>
      </span>
    </template>

    <modal v-if="modal" @close="closeModal">
      <div slot="modal-title">
        <span v-if="counter > 0">ATENÇÃO! Você poderá fechar esse modal em {{ counter }}s</span>
        <span v-else="">Pendências da Empresa</span>
      </div>
      <div slot="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <div v-if="pendencias.length">
              <p v-if="empresa.ativo">Existem pendências nos seguintes grupos:</p>
              <p v-else="">A empresa está inativa. As pendências não serão consideradas.</p>
            </div>
            <div class="alert alert-success" v-if="!pendencias.length">
              <strong><i class="fa fa-check"></i></strong> Woww! Não existe nenhuma pendência para
              essa empresa!!
            </div>
          </div>
          <div class="col-sm-12">
            <ul class="list-group">
              <li class="list-group-item" v-for="(pendencia, idx) in pendencias" :key="idx">
                <strong>{{ pendencia.name }}</strong>
                <span
                  class="label pull-right"
                  :class="{
                    'label-danger': pendencia.type === 'CRITICAL',
                    'label-warning': pendencia.type !== 'CRITICAL'
                  }"
                  >{{ pendencia.description }}</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  EmpresaValidation,
  EmpresaNoValidation,
  FieldNames,
  EmpresaPessoaFisicaValidation
} from '../../models/Empresa'
import ValidationUtils from '../../utils/ValidationUtils'
import Modal from '../../components/Modal.vue'
import Permissions from '../../models/Permissions'

export default {
  name: 'empresa-detalhes',
  props: {
    value: {
      required: true
    },
    showModalOnMount: {
      default: true
    },
    type: {
      default: 'normal',
      type: String
    },
    linkTitle: {
      default: 'normal',
      type: String
    },
    circle: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      empresa: {},
      modal: false,
      canClose: true,
      counter: 5,
      permissions: Permissions
    }
  },
  mounted() {
    this.empresa = this.value
    if (this.usuarioLogado.level.idNivel !== this.permissions.ADMINISTRADOR) {
      this.begin()
    }
  },
  methods: {
    checkNeedOpenModal() {
      if (this.percentual < 50) {
        // Modificado de 100 pra 50 devido a nova maneira de pesquisa de empresa parcial/completa
        this.canClose = false
        this.modal = true
        this.counter = 5
        this.triggerCounter()
        setTimeout(() => {
          this.canClose = true
        }, 5 * 1000)
      } else {
        this.counter = 0
      }
    },

    onClick() {
      this.$emit('on-click')
    },

    triggerCounter() {
      setTimeout(() => {
        if (this.counter > 0) {
          this.counter--
          this.triggerCounter()
        }
      }, 1000)
    },

    closeModal() {
      if (this.canClose) {
        this.modal = false
      }
    },

    begin() {
      if (this.showModalOnMount) {
        this.checkNeedOpenModal()
      } else {
        this.counter = 0
      }
    }
  },
  computed: {
    pendencias() {
      return this.empresa.ativo ? ValidationUtils.checkPendencies(this.$v.empresa, FieldNames) : []
    },

    percentual() {
      return this.empresa.ativo
        ? ValidationUtils.getPercentage(this.$v.empresa, FieldNames) || 0
        : 100
    },

    style() {
      return `width: ${this.percentual}%;`
    },

    usuarioLogado() {
      return this.$store.getters.getUser
    },

    tipoPessoa() {
      return this.empresa.cnpj
        ? this.empresa.cnpj.length === 11
          ? 'FISICA'
          : 'JURIDICA'
        : 'JURIDICA'
    }
  },
  validations() {
    return {
      empresa: this.empresa.ativo
        ? this.tipoPessoa === 'JURIDICA'
          ? EmpresaValidation()[this.empresa.analise]
          : EmpresaPessoaFisicaValidation[this.empresa.analise]
        : EmpresaNoValidation
    }
  },
  watch: {
    value(newValue) {
      this.empresa = newValue
      this.counter = 0
      this.begin()
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="css" scoped>
.text-white {
  white-space: nowrap;
  color: #fff;
}

.circulo {
  border: 1px solid #ccc;
  border-radius: 50%;
  width: 35px;
  height: 35px;
}

.background-yellow {
  background-color: #ffd600;
}

.progress {
  margin-bottom: 0px;
  min-width: 135px;
}

.label {
  font-size: 100%;
}
</style>
